import { render, staticRenderFns } from "./Transactions.vue?vue&type=template&id=53122cae&scoped=true"
import script from "./Transactions.vue?vue&type=script&lang=ts"
export * from "./Transactions.vue?vue&type=script&lang=ts"
import style0 from "./Transactions.vue?vue&type=style&index=0&id=53122cae&prod&scoped=true&lang=css"
import style1 from "./Transactions.vue?vue&type=style&index=1&id=53122cae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53122cae",
  null
  
)

export default component.exports